import React, { useEffect, useState } from "react";
import "./function.css";
import { Oil } from "../../api";

export default function Function12({ machineID, data, machineInfo }) {
  const [state, setState] = useState(data || {});
  const { IP, port } = machineInfo;

  const fetchDeviceStatus = async () => {
    try {
      const response = await Oil.getDeviceStatus(IP, port);
      if (response.code === 200) {
        setState((prevState) => ({
          ...prevState,
          contact_signal: response.data.is_online ? response.data.status : "-", // MQTT 關閉時顯示 "-"
          time: response.data.time,
          is_online: response.data.is_online,
        }));
      }
    } catch (error) {
      console.error("Failed to fetch device status:", error);
    }
  };

  useEffect(() => {
    fetchDeviceStatus(); // 初次載入時獲取最新的設備狀態
    const intervalId = setInterval(() => {
      if (state.is_online) {
        // 只有 MQTT 連線時才繼續抓取數據
        fetchDeviceStatus();
      }
    }, 10000); // 10秒抓一次
    return () => clearInterval(intervalId); // 在組件卸載時清除定時器
  }, [state.is_online]); // 依賴 is_online，當變化時會重新執行

  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center h-100">
          <div className="d-flex align-items-center">
            <div>
              <span className="font-weight-bold mr-1">{`編號:`}</span>
              <span className="mr-3 text-nowrap">{`${machineID}`}</span>
            </div>
            <div>
              <span className="font-weight-bold mr-1">{`狀態:`}</span>
              <span className="text-nowrap">{`${state.contact_signal}`}</span>
            </div>
          </div>
        </div>
      </td>
    </React.Fragment>
  );
}
